import { z } from 'zod';

const ymdSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine((value) => {
  const [year, month, day] = value.split('-').map(Number);
  const parsed = new Date(Date.UTC(year!, month! - 1, day));
  return parsed.getUTCFullYear() === year
    && parsed.getUTCMonth() + 1 === month
    && parsed.getUTCDate() === day;
}, 'Data inválida.');

const centsSchema = z.number().int().safe().nonnegative();

export const fortnightlyCategorySchema = z.object({
  categoryId: z.string().min(1),
  name: z.string().min(1).max(120),
  color: z.string().min(1).max(32),
  icon: z.string().min(1).max(80),
  totalCents: centsSchema,
  previousTotalCents: centsSchema.nullable(),
  changeBasisPoints: z.number().int().safe().nullable(),
}).strict();
export type FortnightlyCategory = z.infer<typeof fortnightlyCategorySchema>;

export const pendingCommitmentSchema = z.object({
  transactionId: z.string().min(1),
  description: z.string().min(1).max(240),
  date: ymdSchema,
  type: z.enum(['income', 'expense']),
  amountCents: centsSchema,
  categoryName: z.string().min(1).max(120),
}).strict();
export type PendingCommitment = z.infer<typeof pendingCommitmentSchema>;

export const financialInsightSchema = z.object({
  kind: z.enum(['positive', 'warning', 'opportunity']),
  title: z.string().min(1).max(120),
  body: z.string().min(1).max(360),
}).strict();
export type FinancialInsight = z.infer<typeof financialInsightSchema>;

export const fortnightlyReportSchema = z.object({
  id: z.string().min(1),
  periodStart: ymdSchema,
  periodEnd: ymdSchema,
  reportKind: z.enum(['midmonth', 'month', 'legacy_second_half']),
  title: z.string().trim().min(1).max(160),
  summary: z.string().trim().min(1).max(1200),
  incomeCents: centsSchema,
  expenseCents: centsSchema,
  pendingIncomeCents: centsSchema,
  pendingExpenseCents: centsSchema,
  balanceCents: z.number().int().safe(),
  previousExpenseCents: centsSchema.nullable(),
  expenseChangeBasisPoints: z.number().int().safe().nullable(),
  topCategories: z.array(fortnightlyCategorySchema).max(5),
  pendingCommitments: z.array(pendingCommitmentSchema).max(100),
  insights: z.array(financialInsightSchema).max(4),
  createdAt: z.string().datetime(),
}).strict();
export type FortnightlyReport = z.infer<typeof fortnightlyReportSchema>;

export const fortnightlyReportsResponseSchema = z.object({
  reports: z.array(fortnightlyReportSchema),
}).strict();
export type FortnightlyReportsResponse = z.infer<typeof fortnightlyReportsResponseSchema>;
